module.exports = __webpack_public_path__ + "img/bammer_img.647916b1.png";